import { DropdownMenuLabel } from "../../../ui/dropdown-menu";
import { MenuLabelType } from "../types";

export const MenuLabelItem = ({ menuItem }: { menuItem: MenuLabelType }) => {
  return (
    <DropdownMenuLabel className="text-purple-muted-300 px-3 font-normal">
      {menuItem.label}
    </DropdownMenuLabel>
  );
};
